<template>
  <div class="card">
    <div class="card-body">
      <h5 class="fw-bold mb-3">Provide Orders</h5>
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: mode === 'single' }"
            href="#"
            @click.prevent="mode = 'single'"
            >Single UUID</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: mode === 'bulk' }"
            href="#"
            @click.prevent="mode = 'bulk'"
            >Bulk List</a
          >
        </li>
      </ul>

      <div v-if="mode === 'single'" class="mb-3">
        <label for="single-uuid" class="form-label">Order UUID</label>
        <input
          id="single-uuid"
          v-model="singleUuid"
          class="form-control border border-primary"
          placeholder="aaaaaaaa-aaaa-4aaa-aaaa-aaaaaaaaaaaa"
        />
      </div>

      <div v-if="mode === 'bulk'">
        <div class="mb-2">
          <input
            type="file"
            accept=".txt,.csv"
            class="form-control border border-primary"
            @change="onFile"
          />
        </div>
        <label for="bulk-textarea" class="form-label">Or Paste (One UUID Per Line)</label>
        <textarea
          id="bulk-textarea"
          v-model="bulkText"
          class="form-control border border-primary"
          rows="8"
        />
      </div>

      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="emit('back')">Back</button>
        <button
          class="btn btn-primary"
          :disabled="parsed.length === 0"
          @click="emit('next', parsed)"
        >
          Review {{ parsed.length }} UUID(s)
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

const emit = defineEmits<{ (e: 'next', uuids: string[]): void; (e: 'back'): void }>();

const mode = ref<'single' | 'bulk'>('single');
const singleUuid = ref('');
const bulkText = ref('');

const parsed = computed<string[]>(() => {
  if (mode.value === 'single') {
    const u = singleUuid.value.trim();
    return u ? [u] : [];
  }
  return bulkText.value
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
});

function onFile(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (ev) => {
    bulkText.value = String(ev.target?.result ?? '');
  };
  reader.readAsText(file);
}
</script>
